import ModalFeedback from "components/modal-feedback/modal-feedback"

export default function run() {
  const { FCGON } = window

  // Automatic startup on the dedicated sign up page
  if (FCGON && FCGON.modal_feedback_immediately) {
    ModalFeedback({ backdrop: false, position: "right" })
  }
}
